import React from 'react'
import Box from "@mui/material/Box";

import './CalculatePage.scss'
import {CalcPageInfo} from "./CalcPageInfo";
import classnames from "classnames";
import {LocationModal} from "../DealPage/LocationModal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {useCalcContext} from "../../contexts/CalcContext";
import {LEASE_DEAL_LIGHT} from "../../contexts/DealContext";
import Button from "@mui/material/Button";
import ReplayIcon from '@mui/icons-material/Replay';
import {MiniLeadItem} from "../DealPage/DealCRMPage/MiniLeadItem";
import {useModalsStore} from "../../stores/modalsStore";

export const CalculatePage = () => {
    const { calcState, setCalcState, resetCalcState, getLeadId } = useCalcContext()
    const closeModalById = useModalsStore((state) => state.closeModalById)

    const saveLocation = (location) => {
        setCalcState({
            ...calcState,
            location_id: location.id,
            location: location,

            address_line_one: location.address_line_one,
            address_line_two: location.address_line_two,
            city: location.city,
            state: location.state,
            zipcode: location.zipcode,
            county: location.county,
        }, false)
        closeModalById("LocationModal")
    }

    const isPurchase = calcState.is_purchase

    return (
        <Box id={"CalculatePage"}
             className={classnames('', {
                 isPurchase: isPurchase
             })}
        >
            <Stack
                justifyContent={'center'}
                style={{ width: '100%' }}
            >
                <Typography
                    gutterBottom
                    variant="h6"
                    component="div"
                    className={'header'}
                    sx={{
                        fontSize: '24px',
                        fontWeight: '400',
                        marginBottom: '10px',
                        color: "#666666",
                        whiteSpace: 'pre-wrap'
                    }}
                >
                    <Stack
                        justifyContent={'flex-start'}
                        direction="row"
                        alignItems={'center'}
                    >
                        Calculate
                        {
                            getLeadId() &&
                                <React.Fragment>
                                    <span> for lead</span>
                                    <MiniLeadItem leadId={getLeadId()}/>
                                </React.Fragment>
                        }
                        <Button
                            className={'calc-reset-button'}
                            style={{ background: LEASE_DEAL_LIGHT }}
                            onClick={resetCalcState}
                        >
                            Reset <ReplayIcon/>
                        </Button>
                    </Stack>
                </Typography>


                <CalcPageInfo saveLocation={saveLocation}/>
            </Stack>
        </Box>
    )
}